import { ReactNode } from 'react';
import {
  Popper as MUIPopper,
  PopperProps as MUIPopperProps,
} from '@mui/material';

type AtomMUIProps = {
  open: boolean;
  children?: ReactNode;
  anchorEl?: Element;
  disablePortal?: boolean;
  keepMounted?: boolean;
  onClose?: () => void;
  placement?: any;
  popperOptions?: any;
  modifiers?: any;
};

export type PopperProps = AtomMUIProps;

export const Popper = (props: PopperProps) => {
  const MUIProps: MUIPopperProps = props;

  return <MUIPopper {...MUIProps} />;
};

export default Popper;
